import { PostJourneysSearchJourneyRequest } from 'src/sdk_checkin';

/**
 * CheckinCommon model
 * @param journeyId チェックイン検索にて取得された、チェックイン対象journeyId
 * @param searchType チェックイン検索にて指定された検索条件
 * @param orderId チェックイン検索の際に指定された予約番号
 * @param travelDocumentId チェックイン検索の際に指定された航空券番号
 * @param firstName チェックイン検索の際に指定された搭乗者の名
 * @param lastName チェックイン検索の際に指定された搭乗者の姓
 * @param searchedTravelerName チェックイン検索の際に指定された搭乗者の姓名
 * @param numberOfTravelers journeyに含まれる搭乗者の数(同伴幼児を含まない)
 * @param selectedFlightIds チェックイン対象として選択された、セグメントのID配列
 * @param previousPageIdentifier どの画面からの遷移かを示す識別子
 * @param seatMapDisplayFlightId シートマップ表示セグメントID
 * @param reservationDetailIdentifier 予約詳細からの遷移かどうかを示す識別子
 * @param isSkipCheckinPassengerInput チェックイン搭乗者情報入力画面スキップフラグ
 * @param isSkipCheckinSeatmap チェックインシートマップ画面スキップフラグ
 */
export interface CheckinCommonModel {
  journeyId?: string;
  searchType?: PostJourneysSearchJourneyRequest.SearchTypeEnum;
  orderId?: string;
  travelDocumentId?: string;
  firstName?: string;
  lastName?: string;
  searchedTravelerName?: string;
  numberOfTravelers?: number;
  selectedFlightIds?: string[];
  previousPageIdentifier?: string;
  seatMapDisplayFlightId?: string;
  reservationDetailIdentifier?: typeof RESERVATION_DETAIL_IDENTIFIER | '';
  isSkipCheckinPassengerInput?: boolean;
  isSkipCheckinSeatmap?: boolean;
}

// 予約詳細から遷移してきたことを示す識別子
export const RESERVATION_DETAIL_IDENTIFIER = 'reservation';
